import { scopedStorageKey } from '../persistence/accountScope';
import { V2_SERVER_PURGE_KEY } from '../persistence/persistenceContract';
import { purgeInspectionOnServer } from './aiJobsStore';

// THE SERVER HALF OF "GENERATE DELETES THE PROCESS DATA" (Owner decision list 2026-10-19 items 1 / 2).
// The device deletes its working data in the same transaction as the final report (OD-12,
// src/state/reportStore.ts). The server's AI review records of that inspection are deleted by a call
// that needs the network: the inspection id is queued per account and the call is retried — after the
// generation, on every sign-in and whenever the app comes back to the front — until the server confirms.
function read(): string[] {
  try {
    const key = scopedStorageKey(V2_SERVER_PURGE_KEY);
    if (key === null) return [];
    const parsed = JSON.parse(window.localStorage.getItem(key) ?? '[]') as unknown;
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string' && id.length > 0) : [];
  } catch {
    return [];
  }
}

function write(ids: readonly string[]): void {
  try {
    const key = scopedStorageKey(V2_SERVER_PURGE_KEY);
    if (key === null) return;
    if (ids.length === 0) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, JSON.stringify([...new Set(ids)]));
  } catch {
    // storage refusal must never block field work; the next generation queues again
  }
}

export function pendingServerPurges(): string[] {
  return read();
}

let flushing: Promise<void> | null = null;

export async function flushServerPurges(): Promise<void> {
  if (flushing) return flushing;
  flushing = (async () => {
    for (const inspectionId of read()) {
      const done = await purgeInspectionOnServer(inspectionId);
      if (!done) return;
      write(read().filter((id) => id !== inspectionId));
    }
  })();
  try {
    await flushing;
  } finally {
    flushing = null;
  }
}

export async function requestServerPurge(inspectionId: string): Promise<void> {
  write([...read(), inspectionId]);
  await flushServerPurges();
}
